/**
 * Abstracted API error type that decouples components from axios
 * Use this instead of importing AxiosError directly in components
 */
export type ApiError<T = unknown> = {
  response?: {
    status?: number;
    data?: T;
    statusText?: string;
  };
  message: string;
  config?: unknown;
  code?: string;
  request?: unknown;
};

/**
 * Type guard to check if an error is an API error
 * Use this instead of importing isAxiosError from axios
 */
export function isApiError(error: unknown): error is ApiError {
  return (
    typeof error === "object" &&
    error !== null &&
    "message" in error &&
    ("response" in error || "config" in error || "request" in error)
  );
}
